module.exports = __webpack_public_path__ + "static/img/thenoteslist.be7e67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thenoteslist.png
// module id = 1103
// module chunks = 21